import { APIGATEWAY_BASE_URL } from 'src/dataLayer/env'
import { getTrackingUUID } from 'src/dataLayer/localData/cookies'
import { reportAPIFailure } from 'src/dataLayer/remoteData/rollbar'

const ERROR_KEYS = {
  422: {
    key: 'change_password_page.error_message_timeout',
  },
  default: {
    key: 'change_password_page.error_message_generic',
  },
}

const getPayload = ({ captchaResponseToken, confirmPassword, password, passwordResetToken }) => {
  const payload = {
    account: {
      captcha: {
        token: captchaResponseToken,
      },
      password,
      password_confirmation: confirmPassword,
      token: passwordResetToken,
    },
  }
  return payload
}

const getHeaders = () => {
  const headers = {
    'Content-Type': 'application/json',
    'X-Babbel-Tracking-UUID': getTrackingUUID(),
  }
  return headers
}

export default async (properties) => {
  try {
    const response = await fetch(
      `${APIGATEWAY_BASE_URL}/v5/${properties.locale}/passwords/update`,
      {
        body: JSON.stringify(getPayload(properties)),
        headers: getHeaders(),
        method: 'PUT',
      },
    )

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}))
      const errorKey = ERROR_KEYS[response.status]?.key || ERROR_KEYS.default.key
      reportAPIFailure(
        { ...errorData.error, status: response.status },
        { endpoint: 'passwords/update' },
      )
      return {
        data: errorData,
        error: errorKey,
        status: response.status,
        success: false,
      }
    }

    const data = await response.json()
    return {
      data,
      success: true,
    }
  } catch (error) {
    reportAPIFailure(error, { endpoint: 'passwords/update' })
    return {
      error: ERROR_KEYS.default.key,
      message: error.message,
      networkError: true,
      success: false,
    }
  }
}

export { ERROR_KEYS }
